document.addEventListener( 'DOMContentLoaded', function() {
  // Select all images with loading="lazy"
  const lazyImages = document.querySelectorAll( '.e-div--logo-card-inner img[loading="lazy"]' );
  lazyImages?.forEach( function( img ) {
    img.removeAttribute( 'loading' ); // Remove the loading attribute
  } );
} );